import React from 'react';

import westernUnion from 'images/icon-western-union.png';

const WesternUnion = ({ size = 18, className }) => (
  <img src={westernUnion} style={{ height: size, width: size }} className={className} />
);

export default WesternUnion;
